module.exports = __webpack_public_path__ + "img/vrbox.acd05dee.png";